import { reportDebug } from '@PROJECT_ROOT/assets/responsive-frontend/js/services/reportService';
import windowManipulationService from '@PROJECT_ROOT/assets/responsive-frontend/js/services/windowManipulationService';
import { IS_FRAME_SERVICE } from '@PROJECT_ROOT/assets/responsive-frontend/js/services/frameService';

export default function initFetchWithOneRetry() {
    const isClientSideRendering = windowManipulationService.isBrowserEnvironment();
    const axiosInstanceQueryParams = {};
    if (isClientSideRendering && ADRIATIC_PARTNER_RESPONSIVE_SCHEME_HOST === `${window.location.protocol}//${window.location.hostname}`) {
        const params = new URLSearchParams(window.location.search);
        const fsSet = params.get('fs_set');
        if (fsSet) {
            axiosInstanceQueryParams.fs_set = fsSet;
        }
    }

    function maybeAppendFsSet(url) {
        const fsSet = axiosInstanceQueryParams && axiosInstanceQueryParams.fs_set;
        if (!fsSet) return String(url);

        try {
            const base = IS_FRAME_SERVICE ? ADRIATIC_PARTNER_RESPONSIVE_SCHEME_HOST : ADRIATIC_RESPONSIVE_SCHEME_HOST;
            const u = new URL(String(url), base);
            if (!u.searchParams.has('fs_set')) {
                u.searchParams.set('fs_set', fsSet);
            }
            return u.toString();
        } catch {
            // Fallback for non-standard URLs; preserve hash if any
            const s = String(url);
            const [head, hash = ''] = s.split('#');
            const sep = head.includes('?') ? '&' : '?';
            return `${head}${sep}fs_set=${encodeURIComponent(fsSet)}${hash ? `#${hash}` : ''}`;
        }
    }

    async function fetchWithOneRetry(url, { delayMs = 800, timeoutMs = 8000, fetchOptions = {} } = {}) {
        const attempt = async () => {
            const controller = new AbortController();
            const t = setTimeout(() => controller.abort(new DOMException('timeout', 'AbortError')), timeoutMs);
            try {
                const finalUrl = maybeAppendFsSet(url);
                // Always pass a Request so any SW/polyfill that expects .clone() won’t crash.
                const method = fetchOptions.method || 'GET';
                const req = new Request(finalUrl, {
                    // Ensure we don’t accidentally reuse a body after a retry.
                    ...fetchOptions,
                    method,
                    body: method === 'GET' ? null : (fetchOptions.body ?? null),
                    signal: controller.signal,
                });
                const res = await fetch(req);
                if (res.ok) {
                    return await res.text();
                }
                throw new Error(`HTTP ${res.status} ${res.statusText}`);
            } finally {
                clearTimeout(t);
            }
        };
        const generalErrorMessage = 'Ukoliko se radi o bujici istovetnih logova problem je u našoj mreži. U protivnom je korisnik kojem je u trenutku opala kvaliteta mrežne veze.';
        try {
            return await attempt();
        } catch (firstErr) {
            reportDebug(new Error(`URL "${url}" nije dohvaćen iz prvog pokušaja: "${firstErr.message}". ${generalErrorMessage}`));
            // TODO: Potrebno odraditi po pravilima.
            // eslint-disable-next-line no-promise-executor-return
            await new Promise((r) => setTimeout(r, delayMs));
            try {
                return await attempt();
            } catch (secondErr) {
                reportDebug(new Error(`URL "${url}" nije dohvaćen ni nakon prvog pokušaja: "${secondErr.message}" (prvi pokušaj: "${firstErr.message}"). ${generalErrorMessage}`));
            }
        }

        return '';
    }

    if (typeof window !== 'undefined' && typeof window.fetchWithOneRetry !== 'function') {
        Object.defineProperty(window, 'fetchWithOneRetry', {
            value: fetchWithOneRetry,
            writable: false,
            configurable: false,
        });
    }
}
